var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.333 2C1.597 2 1 2.597 1 3.333v9.334C1 13.403 1.597 14 2.333 14h11.334c.736 0 1.333-.597 1.333-1.333V3.333C15 2.597 14.403 2 13.667 2H2.333zm2.36 2.939a.533.533 0 10-.718.789l2.77 2.518c.711.647 1.799.647 2.51 0l2.77-2.518a.533.533 0 10-.717-.79l-2.77 2.519a.8.8 0 01-1.076 0l-2.77-2.518z",
    fill: "#386EE7"
  })));
}
export default __webpack_public_path__ + "static/mail_other.fd826c47.svg";
export { SvgMailOther as ReactComponent };